var initial_viewportHeight = document.documentElement && document.documentElement.clientHeight ? document.documentElement.clientHeight : (window.innerHeight ? window.innerHeight:800);

function fullscreen_row_padding_compensation_apply_to_row(el)
{
    $(el).css({minHeight:(initial_viewportHeight)+'px'})

    var aw = $(el).find('.page_row_content > .page_row_grid');
    var a = $(el).find('.page_row_overlay');
    var pad = parseInt(a.css('padding-top')) + parseInt(a.css('padding-bottom'))
    //console.log(aw,a,pad);
    if(aw.length>0)
        pad += parseInt(aw.css('border-top-width')) + parseInt(aw.css('border-bottom-width'))

    //console.log(initial_viewportHeight,pad);

    a.css({minHeight:(initial_viewportHeight - pad)+'px'})

    $(el).find('.page_row_background').css({minHeight:initial_viewportHeight+'px'});

    $(el).find('.page_row_grid').css({minHeight:(initial_viewportHeight - pad)+'px'})
    $(el).find('.page_row_gridlayout').css({minHeight:(initial_viewportHeight - pad)+'px',height:'1px'})

    $(el).find('.page_row_grid .grid_cell_wrapper').each(function(){
        // pas applicable pour les gridlayout
        if($(this).parents('.page_row_gridlayout').length>0)
            return;

        let i = $(this).attr('data-row-level');
        let rd = $(this).parents('.grid_nested_rows');
        rd = rd.length>0 ? parseInt(rd.eq(0).attr('data-row-division')) : 1;
        let bh = 100 / rd;
        let mh = bh / i;
        $(this).css({minHeight:(initial_viewportHeight*bh/100 - pad)+'px'})
        $(this).find('.cell_container').css({minHeight:(initial_viewportHeight*mh/100 - pad)+'px'})
    })
}

function fullscreen_row_padding_compensation()
{
    var w = $('body').width();

    if(w>1100)
    {
        $('.page_row[data-fullscreen="false"]').css({'minHeight':''});
        $('.page_row[data-fullscreen="false"] .page_row_background').css({'minHeight':''});
        $('.page_row[data-fullscreen="false"] .page_row_overlay').css({'minHeight':''});
        $('.page_row[data-fullscreen="false"] .page_row_grid').css({'minHeight':''});
        $('.page_row[data-fullscreen="false"] .page_row_grid .grid_cell_wrapper').css({'minHeight':''});
        $('.page_row[data-fullscreen="false"] .page_row_grid .cell_container').css({'minHeight':''});
        $('.page_row[data-fullscreen="false"] .page_row_gridlayout').css({'minHeight':'',height:''});

        $('.page_row[data-fullscreen="true"]').each(function(){
            fullscreen_row_padding_compensation_apply_to_row(this)
        })
    }
    else if(w>980)
    {
        $('.page_row[data-tablet-fullscreen="false"]').css({'minHeight':''});
        $('.page_row[data-tablet-fullscreen="false"] .page_row_background').css({'minHeight':''});
        $('.page_row[data-tablet-fullscreen="false"] .page_row_overlay').css({'minHeight':''});
        $('.page_row[data-tablet-fullscreen="false"] .page_row_grid').css({'minHeight':''});
        $('.page_row[data-tablet-fullscreen="false"] .page_row_grid .grid_cell_wrapper').css({'minHeight':''});
        $('.page_row[data-tablet-fullscreen="false"] .page_row_grid .cell_container').css({'minHeight':''});
        $('.page_row[data-tablet-fullscreen="false"] .page_row_gridlayout').css({'minHeight':'',height:''});

        $('.page_row[data-tablet-fullscreen="true"]').each(function(){
            fullscreen_row_padding_compensation_apply_to_row(this)
        })
    }
    else
    {
        $('.page_row[data-mobile-fullscreen="false"]').css({'minHeight':''});
        $('.page_row[data-mobile-fullscreen="false"] .page_row_background').css({'minHeight':''});
        $('.page_row[data-mobile-fullscreen="false"] .page_row_overlay').css({'minHeight':''});
        $('.page_row[data-mobile-fullscreen="false"] .page_row_grid').css({'minHeight':''});
        $('.page_row[data-mobile-fullscreen="false"] .page_row_grid .grid_cell_wrapper').css({'minHeight':''});
        $('.page_row[data-mobile-fullscreen="false"] .page_row_grid .cell_container').css({'minHeight':''});
        $('.page_row[data-mobile-fullscreen="false"] .page_row_gridlayout').css({'minHeight':'',height:''});

        $('.page_row[data-mobile-fullscreen="true"]').each(function(){
            fullscreen_row_padding_compensation_apply_to_row(this)
        })
    }
}

var fullscreen_row_padding_compensation_delay = null;
var fullscreen_row_padding_compensation_initiate = function()
{
    clearTimeout(fullscreen_row_padding_compensation_delay);
    fullscreen_row_padding_compensation_delay = setTimeout(fullscreen_row_padding_compensation,100);
}
$(document).ready(fullscreen_row_padding_compensation_initiate)
$(window).on('resize',fullscreen_row_padding_compensation_initiate);
$(window).on('scroll',fullscreen_row_padding_compensation_initiate);


// Fix content part2 slidein transition -- No way to make a smooth and event css transition on automatic height property
$(document).on('mouseover','.cell_container',function(){
    $(this).find('.part_1[data-text-transition="slidein"]').each(function(){
        let el= $(this).find('.part_1_2');
        let H = el.find('.part_wrapper').outerHeight();;
        $(this).find('.part_1_2').css({maxHeight:H+'px'});
    });
});
$(document).on('mouseout','.cell_container',function(){
    $(this).find('.part_1[data-text-transition="slidein"]').each(function(){
        $(this).find('.part_1_2').css({maxHeight:'0px'});
    });
});

function gridcell_mobile_display_indicator() {
    $('.grid_cell[mobile="false"]:first-child').each(function(){
        $(this).nextAll(':visible').first().addClass('mobile-first-child');
    });
    $('.grid_cell[mobile="false"]:last-child').each(function(){
        $(this).prevAll(':visible').first().addClass('mobile-last-child');
    })
}
$(document).ready(gridcell_mobile_display_indicator)
$(window).on('resize',gridcell_mobile_display_indicator);


// gridlayout cell min height adjustment
function gridlayout_cell_minheigh_adjust(reset=false)
{
    if(reset)
    {
        //console.log('reset grid cell size');
        $('.gridlayout_cell> .grid_cell_wrapper').css({'minHeight':'',height:''});
    }

    $('.gridlayout_cell').each(function(){
        $(this).find('> .grid_cell_wrapper').css({minHeight:$(this).innerHeight()+'px'});
    })
}

$(document).ready(function(){
    $('.gridlayout_cell> .grid_cell_wrapper').css({'minHeight':'',height:''});
    gridlayout_cell_minheigh_adjust(true);
    setTimeout(function(){ gridlayout_cell_minheigh_adjust(true) },500)
    setTimeout(function(){ gridlayout_cell_minheigh_adjust(true) },1000)
    setTimeout(function(){ gridlayout_cell_minheigh_adjust(true) },1500)
    setTimeout(function(){ gridlayout_cell_minheigh_adjust(true) },2000)
});
$(window).on('resize',function() { gridlayout_cell_minheigh_adjust(true) });